import en from './en.json';
import de from './de.json';

const sharedLocales = {
  en,
  de
};

export default sharedLocales;